/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import BobModal from '../../../components/BobModal';
import { Editor, EditorTools, EditorUtils  } from '@progress/kendo-react-editor';

const AnnouncementModal = ({
    selectedAnnouncement,
    onClose,
    close,
    open,
    title,
    ...props
}) => {

    const handleClose = () => {
        close();
    };

    const onMount = (event) => {
        setTimeout(function() {
            // eslint-disable-next-line no-undef
            let frame = document.getElementsByClassName('k-iframe');
            if (frame && frame.length>0) {
                let content  = frame[0].contentDocument.getElementsByClassName('ProseMirror');
                // let bt = frame[0].contentDocument.createElement('base');
                // bt.setAttribute('target','_blank');
                if (content && content.length>0) {
                    content[0].setAttribute('contenteditable',false);
                }      
            }},1500);
    };


    return (
        <BobModal
            onCancel={handleClose}
            onClose={handleClose}
            rootClass={'announcement-modal'}
            open={open}
            cancelText={'Close'}
            subTitle={`V ${selectedAnnouncement.version}`}
            applyHidden={true}
            isRemoveFooter={false}
            title={title}
        >
            <div>
                <div>
                    <div>
                        <Editor
                            value={selectedAnnouncement.announcementContent}
                            contentStyle={{
                                height: 'calc(96vh - 160px)'
                            }}
                            immutables={true}
                            onMount={onMount}
                            defaultContent={selectedAnnouncement.announcementContent}
                        />    
                    </div>
                </div>

            </div>
        </BobModal>
    );
};

AnnouncementModal.propTypes = {

};

const mapStateToProps = state => {
    return {

    };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementModal);
